import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/communication/cards/communication-1.jpg';


const CommunicationPagedata = () => {


    return (
        <section style={{ marginTop: '40px' }}>
            <div className="container">


                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(236 115 34)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                                Media & <span style={{ color: '#000' }}> Communication</span>

                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    At DREBCON, we empower the Communication Industry by addressing critical challenges in cybersecurity, regulatory compliance, and network resilience, enabling organizations to safeguard digital infrastructure, optimize operational performance, and drive next-generation connectivity.
                                </p>
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    Our expertise integrates advanced IT and telecom security frameworks to protect core networks, cloud platforms, and critical communication systems, ensuring the resilience of 5G, satellite, and broadband infrastructures. By embedding intelligent risk management systems and robust governance models, we mitigate cyber threats, enhance data privacy, and ensure compliance with DoT Security Guidelines, NCIIPC Critical Infrastructure Protection, TRAI Regulations, and CERT-In Directives.
                                </p>

                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                    With a focus on secure, compliant, and scalable solutions, DREBCON enables telecom service providers, ISPs, cloud platforms, and satellite operators to thrive in a rapidly evolving landscape while building trust, strengthening digital security, and driving innovation in global communication ecosystems.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg1} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%', marginTop: '40px' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CommunicationPagedata;
